import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RATE_FILTERS_EDIT } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { allRateFiltersSelector } from '../../../../property/propertySlice';

const RateFiltersView = (props) => {
  const { rateFilter, onViewToggle, toggleDrawer, selectedHotel, permissions } = props;
  const [selectedRateFilter, setSelectedRateFilter] = useState(rateFilter);

  const originalRateFilters = useSelector(allRateFiltersSelector);

  useEffect(() => {
    const rateFilterObj = {
      ...originalRateFilters.find((tempRateFilter) => tempRateFilter.id === rateFilter.id),
    };
    setSelectedRateFilter(rateFilterObj);
  }, [selectedHotel, originalRateFilters]);

  const onClickEdit = (event) => {
    toggleDrawer(RATE_FILTERS_EDIT, true, selectedRateFilter);
  };

  console.log(selectedRateFilter);

  const renderScreen = () => {
    return (
      <div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-6'>
            <div className='details-label'>Rate Filter name</div>
            <div className='details-value preview-breaks'>
              {selectedRateFilter?.name ? selectedRateFilter.name : '- - -'}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='details-label'>Status</div>
            <div className='details-value'>
              <div
                className={`${
                  selectedRateFilter.isActive ? 'pill-active' : 'pill-inactive'
                } col-md-2 pill-text pill mt-1`}
              >
                {selectedRateFilter.isActive ? 'Active' : 'Inactive'}
              </div>
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-6'>
            <div className='details-label'>Rate Filter Code</div>
            <div className='details-value'>
              {selectedRateFilter?.code ? selectedRateFilter.code : '- - -'}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='details-label'>Display name</div>
            <div className='details-value'>
              {selectedRateFilter?.displayName ? selectedRateFilter.displayName : '- - -'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>
              {selectedRateFilter?.description ? selectedRateFilter.description : '- - -'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Rates codes</div>
            <div className='details-value'>
              {selectedRateFilter?.rateCodes ? selectedRateFilter.rateCodes : '- - -'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Rate Code Description</div>
            <div className='details-value preview-breaks'>
              {selectedRateFilter?.rateCodeDescription
                ? selectedRateFilter.rateCodeDescription
                : '- - -'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          {selectedRateFilter?.customAttributes &&
            selectedRateFilter?.customAttributes?.length > 0 &&
            selectedRateFilter?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </div>
      </div>
    );
  };

  return (
    <>
      {selectedRateFilter && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedRateFilter.name}
          createdUserId={selectedRateFilter.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default RateFiltersView;
